import DataTable from "react-data-table-component";
import Footer from "../components/footer";
import Header from "../components/header";
import React, { useEffect, useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { CartContext } from "../../../contexts/cartContext";
import { CurrencyContext } from "../../../contexts/currencyContext"; // Import context
import { toast, ToastContainer } from 'react-toastify';
import RequestModal from "../components/RequestModal";

const MyWishlist = () => {

    const [wishlistData, setWishlistData] = useState([]);
    const { cart, updateCart, wishlist, updateWishlist } = useContext(CartContext);

    const { currencyContxt } = useContext(CurrencyContext); // Use context

    const navigate = useNavigate();

    // Function to fetch wishlist data
    const fetchWishlistData = async () => {
        const userInfo = JSON.parse(localStorage.getItem('user-info'));
        if (userInfo && userInfo.buyer_id) {
            try {
                const wishlistResponse = await fetch(`https://igapi.heuristticminds.com/api/WishList/Get-GetWishListByUserID?user_id=${userInfo.buyer_id}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${userInfo.token}`,  // Pass user token if required
                    },
                });
                const wishlistData = await wishlistResponse.json();
                setWishlistData(wishlistData);
                updateWishlist(wishlistData); // Update context
            } catch (error) {
                console.error("Error fetching wishlist data:", error);
            }
        } else {
            // Fallback to localStorage if user is not logged in
            const localWishlist = localStorage.getItem('wishlist');
            if (localWishlist) {
                setWishlistData(JSON.parse(localWishlist));
            }
        }
    };

    useEffect(() => {
        fetchWishlistData();
    }, []);



    const columns = [
    {
        cell: (row) => {
            const isSoldOut = row.status === 3 || row.status === 5;

            return (
                <div className="pd_item" key={row.product_id}>
                    <div className="img_box">
                        {/* Sold Out / Sold by Artist Tag */}
                        {row.status === 3 && <span className="soldout-tag">Sold Out</span>}
                        {row.status === 5 && <span className="soldbyartist-tag">Sold by Artist</span>}

                        {/* Product Image */}
                        <img src={`../../../images/products/thumbnail/${row.image}`} className="pd_img" alt="" />
                        <a href="#" className="wishlist_link" title="delete" onClick={() => handleDelete(row.id, row.product_id)}>
                            <i className="bi bi-x"></i>
                        </a>

                        {/* Quick View - Hidden for Sold Items */}
                        {!isSoldOut && (
                            <span className="q_view" onClick={() => handleDetails(row.product_id)}>
                                <i className="bi bi-eye"></i> Quick View
                            </span>
                        )}
                        
                        <span className="size">Size: <b>{row.size}</b></span>

                        {/* Move to Cart - Hidden for Sold Items */}
                        {!isSoldOut && row.price_on_demand !== 1 && (
                            <a className="btn_m" onClick={() => handleMoveToCart(row.id, row.product_id)}>Move to Cart</a>
                        )}
                    </div>
                    <div className="pd_content">
                        <span className="pd_brand">{row.productTitle}</span>
                        <span className="pd_title">{row.category}: {row.categoryType}</span>
                        <span className="pd_title">Art by:
                            <span className="btn_artist1" onClick={() => handleArtist(row.artist_id)}>
                                {row.artistName}
                            </span>
                        </span>

                        {/* Hide Price for Sold Items */}
                        {!isSoldOut && row.price_on_demand !== 1 && (
                            <div className="Price">
                                {currencyContxt.icon} {(row.price / currencyContxt.value).toFixed(2)}
                                {row.discountRate !== 0 && (
                                    <>
                                        <span className="old_price">{currencyContxt.icon} {(row.gstMRP / currencyContxt.value).toFixed(2)}</span>
                                        <span className="discount">({row.discountRate}%)</span>
                                    </>
                                )}
                                {currencyContxt.currency === "INR" && <small>Including GST</small>}
                            </div>
                        )}
                        
                        {/* Request Price Button - Visible only if applicable */}
                        {row.price_on_demand === 1 && !isSoldOut && (
                            <span className="btn_req" onClick={() => handleRequestPrice(row.product_id, row.productTitle)}>Request Price</span>
                        )}
                    </div>
                </div>
            );
        }
    }
];

const paginationComponentOptions = {
    noRowsPerPage: true
};
    
    const handleDelete = async (id, productId) => {
        // Ask for confirmation before deleting
        if (window.confirm('Are you sure you want to delete this item?')) {
            const userInfo = JSON.parse(localStorage.getItem('user-info'));

            if (userInfo && userInfo.buyer_id) {
                // User is logged in, so delete from the database
                try {
                    const deleteResponse = await fetch(`https://igapi.heuristticminds.com/api/WishList/Delete-DeleteWishListDetails?id=${id}`, {
                        method: 'DELETE',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${userInfo.token}`,  // Pass user token if required
                        },
                    });

                    if (deleteResponse.ok) {
                        // Update the wishlist after successful deletion
                        const updatedWishlist = wishlist.filter(item => item.product_id !== productId);
                        updateWishlist(updatedWishlist);  // Update context
                        setWishlistData(updatedWishlist); // Update state

                        toast.success('Item removed from Wishlist!');
                        if (updatedWishlist.length === 0) {
                            toast.info('Your Wishlist is empty. Redirecting to home.');
                            navigate('/'); // Redirect to home if wishlist is empty
                        }
                    } else {
                        toast.error('Failed to delete item from Wishlist.');
                    }
                } catch (error) {
                    console.error("Error deleting item from database:", error);
                    toast.error('Error deleting item from Wishlist.');
                }
            } else {
                // User is not logged in, so delete from localStorage
                const localWishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
                const updatedWishlist = localWishlist.filter(item => item.product_id !== productId);
                localStorage.setItem('wishlist', JSON.stringify(updatedWishlist));

                updateWishlist(updatedWishlist);  // Update context
                setWishlistData(updatedWishlist); // Update state

                toast.success('Item removed from Wishlist!');
                if (updatedWishlist.length === 0) {
                    toast.info('Your Wishlist is empty. Redirecting to home.');
                    navigate('/');
                }
            }
        }
    };

    const handleMoveToCart = async (id, productId) => {
        // Ask for confirmation before deleting
        if (window.confirm('Are you sure you want to Move this Artwork to Cart ?')) {
            // Find the item in the wishlist
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const itemToMove = wishlistData.find(item => item.product_id === productId);

            if (userInfo && userInfo.buyer_id) {
                // User is logged in, move item to cart in the database
                try {
                    // Call the API to move the item to the cart in the database
                    const moveResponse = await fetch(`https://igapi.heuristticminds.com/api/Wishlist/Add-MoveWishListtoCart?id=${id}`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${userInfo.token}`,  // Pass user token if required
                        },
                        body: JSON.stringify({ productId: itemToMove.product_id, userId: userInfo.buyer_id }), // Pass necessary data
                    });

                    if (moveResponse.ok) {
                        // Remove the item from the wishlist in state and context
                        const updatedWishlist = wishlistData.filter(item => item.product_id !== productId);
                        updateWishlist(updatedWishlist);  // Update context
                        setWishlistData(updatedWishlist); // Update state

                        // Optionally update the cart from the server response or make another API call
                        const cartResponse = await moveResponse.json();
                        updateCart(cartResponse.cart);  // Update cart context with the new cart

                        toast.success('Artwork moved to cart!');
                        if (updatedWishlist.length === 0) {
                            navigate('/'); // Redirect to home if the wishlist is empty
                        }
                    } else {
                        toast.error('Failed to move the item to the cart.');
                    }
                }
                catch (error) {
                    console.error('Error moving item to the cart in the database:', error);
                    toast.error('Error moving item to the cart.');
                }
            }
            else {

                // User is not logged in, move item to cart in localStorage
                const localCart = JSON.parse(localStorage.getItem('cart')) || [];
                const updatedCart = [...localCart, itemToMove];
                localStorage.setItem('cart', JSON.stringify(updatedCart));

                // Update the context with the new cart data
                updateCart(updatedCart);

                // Remove the item from the wishlist in localStorage
                const updatedWishlist = wishlistData.filter(item => item.product_id !== productId);
                localStorage.setItem('wishlist', JSON.stringify(updatedWishlist));

                // Update the context and state with the new wishlist data
                updateWishlist(updatedWishlist);
                setWishlistData(updatedWishlist);

                // Show a success message
                toast.success('Artwork moved to cart!');

                if (updatedWishlist.length === 0) {
                    navigate('/'); // Redirect to home if wishlist is empty
                }
            }

        }
    };


    const handleDetails = (id) => {
        navigate(`/artwork/${id}`);
    };

    const handleArtist = (artistId) => {
        navigate(`/artist/${artistId}`);
    };

    const [isModalOpen, setModalOpen] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [selectedPd, setSelectedPd] = useState(null);

    const handleRequestPrice = (id, pdTitle) => {
        setModalOpen(true);
        setSelectedId(id);
        setSelectedPd(pdTitle);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
        setSelectedId(null);
        setSelectedPd(null);
    };

    return (
        <>
            <Header />
            <div style={{ marginTop: '150px' }}>
                <div className="container">
                    <div className="row">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-4">
                                <li className="breadcrumb-item"><Link to={'/'}>Home</Link></li>
                                <li className="breadcrumb-item">My Wishlist</li>
                            </ol>
                        </nav>
                        <div className="col-md-12"><span className="fs-5"><b>My Wishlist</b> {wishlistData.length} items</span></div>
                        <div className="col-md-12 pd-list">
                            <DataTable
                                columns={columns}
                                data={wishlistData}
                                pagination
                                noTableHead
                                paginationComponentOptions={paginationComponentOptions}
                                paginationPerPage={[20]}
                            />
                        </div>
                    </div>
                </div>
                <ToastContainer position="bottom-right" />
            </div>
            <RequestModal isOpen={isModalOpen} onClose={handleCloseModal} id={selectedId} pdTitle={selectedPd} />
            <Footer />
        </>
    )
}

export default MyWishlist;